/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsOutputFormat,
    EfsMelcoEfsModelsOutputFormatFromJSON,
    EfsMelcoEfsModelsOutputFormatFromJSONTyped,
    EfsMelcoEfsModelsOutputFormatToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsOutputFormat>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat
     */
    list: Array<EfsMelcoEfsModelsOutputFormat>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormatFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat {
    return EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormatFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsOutputFormatFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormatToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsOutputFormat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsOutputFormatToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


